import {ActivityAwardItem} from '../../type';

const CURRENT_BONUS_ACTIVITY_TYPES = new Set([
  'PURCHASE_CUMULATE_AMOUNT',
  'RECHARGE_CUMULATE_AMOUNT',
  'WITHDRAW_CUMULATE_AMOUNT',
  'RECHARGE_CUMULATE_COUNT',
  'WITHDRAW_CUMULATE_COUNT',
]);

export const isCurrentBonusActivityType = (activityType?: string) =>
  !!activityType && CURRENT_BONUS_ACTIVITY_TYPES.has(activityType);

export const calculateCurrentCumulateBonus = (
  progressValue: number,
  awardList: ActivityAwardItem[],
) => {
  const currentProgress = Math.max(Number(progressValue) || 0, 0);
  const currentAward = [...awardList]
    .sort((a, b) => (Number(b.minAmount) || 0) - (Number(a.minAmount) || 0))
    .find(item => {
      const minAmount = Number(item.minAmount) || 0;
      const maxAmount = Number(item.maxAmount);
      return (
        currentProgress >= minAmount &&
        (!Number.isFinite(maxAmount) || currentProgress <= maxAmount)
      );
    });

  if (!currentAward) {
    return 0;
  }

  const awardValue = Number(currentAward.value) || 0;
  if (currentAward.valueType === 'PERCENT_VALUE') {
    return (currentProgress * awardValue) / 100;
  }
  return awardValue;
};
